<div class="unit-option-container d-flex justify-content-between px-3 py-3">
  <img src="{{ source }}" class="icon" />
  <div
    class="text-container d-flex flex-column align-items-end justify-content-center"
  >
    <div class="heading">
      <app-with-tooltip [showHelpCursor]="true">{{ title }}</app-with-tooltip>
    </div>
    <div class="text">{{ subTitle }}</div>
  </div>
</div>
